import * as React from 'react';
import styles from './Alert.module.css';
import classNames from 'classnames';
export default function Alert(props) {
    var _a;
    React.useEffect(function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [props.message]);
    return (React.createElement("div", { className: classNames(styles.alert, styles["alert--".concat((_a = props.level) !== null && _a !== void 0 ? _a : 'error')]), onClick: props.close },
        React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.message, dangerouslySetInnerHTML: { __html: props.message } }))));
}
